import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appFieldValue]'
})
export class FieldValueDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/directives/field-value.directive.ts